import { BackendError, Endpoint } from './endpoints/constants'
import { EventType } from '@olagg/db-types'

/**
 * @template B The shape of the data to be sent.
 * @template R The shape of the data to be received.
 * @param _config The endpoint to be used.
 * */

export const fetcherNewsRoom = async <B = any | null, R = B>(
    _config: Endpoint<B>
) => {
    let config: RequestInit = {
        method: _config.method,
    }

    const defaultConfigHeaders = {
        'Content-Type': 'application/json'
    }

    config.headers = _config.headers || defaultConfigHeaders
    config.body = JSON.stringify(_config.body)

    const response = await fetch(
        `${import.meta.env.VITE_API_NEWSROOM_URL}${
            _config.path
        }`,
        config
    )

    const data = (await response.json()) as R | BackendError

    if (response.status >= 400) {
        throw data as BackendError
    }

    return data as R
}

export async function fetcherNewsRoomFake<B = any | null, R = B> (_config: Endpoint<B>): Promise<unknown> {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (_config.path.split('?')[0].endsWith('/last')) resolve(fakeEvents);
            const filter = fakeEvents.filter(event => event.slug === _config.path.split('=')[1]);           
            if (filter.length) resolve(filter[0]);
            reject();
        }, 2000);
    });
}

const fakeEvents: Array<EventType> = [];
// const fakeEvents: Array<EventType> = [
//     {
//         id: 'isdsdfg',
//         hashid: 'sdsdg',
//         slug: 'torneo-duro',
//         title: 'Torneo Duro',
//         lead: 'El torneo mas duro de Lunacia',
//         cover_image: {
//             original: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             thumbnail: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             tiny: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             webp: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             vs: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             s: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             n: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             m: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             h: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             vh: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//             uh: 'https://i0.wp.com/wpp.olagg.io/wp-content/uploads/2023/02/duros.jpg?fit=1920%2C1080&ssl=1',
//         },
//         tags: [ {
//             "id": 407,
//             "name": "nft",
//             "taggings_count": 39
//             },
//             {
//             "id": 548,
//             "name": "Novedades Web3",
//             "taggings_count": 23
//             } ],
//         publication_date: '2023-05-22T09:10:28.000Z',
//         body: 'Bienvenido a otra edicion de **Torneo Duro**.\n \nAquí vamos a conocer al más *Duro* de Lunacia.',
//         calendar: {
//             start: '2033-05-20T09:10:28.000Z',
//             end: '2033-05-20T10:45:00.000Z',
//             link: 'https://www.google.com',
//         },
//         keypoints: '',
//         keywords: '',
//         categories: [],
//         tag_list: [],
//         author: {
//             first_name: 'asd',
//             last_name: 'asd',
//             email: 'asd',
//             profile_image: 'asd'
//         },
//         views: 1,
//         expiration_date: '',
//         updated_at: '',
//         deleted: false

//     },
// ]
